/** Contacto comercial e preços da landing (valores por defeito para o mercado PT). */

export const SOLONLINE_SITE_URL = 'https://solonline.pt'

export const CONTACT_EMAIL =
  (import.meta.env.VITE_SALES_CONTACT_EMAIL as string | undefined)?.trim() || 'info@solonline.pt'

export const PRIVACY_EMAIL =
  (import.meta.env.VITE_SALES_PRIVACY_EMAIL as string | undefined)?.trim() || 'info@solonline.pt'

/**
 * Mensalidade única da plataforma.
 * Sem taxa de setup: um valor mensal dá acesso completo ao espaço GoBooking.
 */
export const MONTHLY_PRICE =
  (import.meta.env.VITE_SALES_MONTHLY_PRICE as string | undefined)?.trim() || '9,70'

/** Comparação “por dia” (≈ mensalidade / 30). */
export const DAILY_COMPARE =
  (import.meta.env.VITE_SALES_DAILY_COMPARE as string | undefined)?.trim() || '0,32'

/** Número WhatsApp da agência, tal como deve aparecer ao cliente. */
export const AGENCY_WHATSAPP_LABEL = String(
  import.meta.env.VITE_AGENCY_WHATSAPP || '+351 961 522 941'
).trim()

/** Número WhatsApp da agência só com dígitos (para links wa.me). */
export const AGENCY_WHATSAPP = AGENCY_WHATSAPP_LABEL.replace(/\D/g, '')

export function agencyWhatsappHref(message: string): string {
  const text = encodeURIComponent(message)
  if (AGENCY_WHATSAPP.length >= 10) return `https://wa.me/${AGENCY_WHATSAPP}?text=${text}`
  return `https://wa.me/?text=${text}`
}

export const WA_ESPACO = agencyWhatsappHref(
  'Olá, Agência Sol OnLine. Quero criar o meu espaço GoBooking — marca exclusiva, sem taxa de setup. Podem orientar-me no plano Grátis ou no Completo (9,70€/mês)?'
)

export const WA_APP = agencyWhatsappHref(
  'Olá, Agência Sol OnLine. Quero a aplicação GoBooking para o meu negócio: a app genérica para os clientes e, no plano Completo, a app com a minha marca.'
)

export const WA_DUVIDA = agencyWhatsappHref('Olá, Agência Sol OnLine. Tenho uma dúvida sobre o GoBooking.')
